module.exports = "https://static.moomoo.com/components/common-redpacket/images/packet-2.48077fef90.png";